import { Tabs } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAuth } from '../../../src/context/AuthContext';
import { AppHeader } from '../../../src/components/AppHeader';
import { CoinIcon } from '../../../src/components/ui';
import { colors, minSafeArea } from '../../../src/theme';

function TabIcon({
  name,
  focused,
}: {
  name: keyof typeof Ionicons.glyphMap;
  focused: boolean;
}) {
  return <Ionicons name={name} size={22} color={focused ? colors.primary : colors.textFaint} />;
}

export default function TabsLayout() {
  const { user, activeMode } = useAuth();
  const insets = useSafeAreaInsets();
  const isOwner = activeMode === 'SHOP_OWNER';
  const isAdmin = user?.role === 'ADMIN';
  // Some browsers report 0 for the safe-area bottom inset until the page has
  // fully settled (or don't report it at all in PWA/standalone mode) — a
  // fixed minimum cushion keeps the tab bar clear of the home indicator /
  // rounded corners either way, on top of whatever real inset is available.
  const tabBarBottomPadding = Math.max(insets.bottom, minSafeArea.bottom);

  return (
    <Tabs
      screenOptions={{
        header: ({ route, options }) => <AppHeader title={options.title ?? route.name} />,
        tabBarActiveTintColor: colors.primary,
        tabBarStyle: {
          height: 56 + tabBarBottomPadding,
          paddingBottom: tabBarBottomPadding,
          paddingTop: 8,
          backgroundColor: colors.card,
          borderTopColor: colors.border,
        },
        tabBarInactiveTintColor: colors.textFaint,
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: isAdmin ? 'Khiếu nại' : isOwner ? 'Shop của tôi' : 'Nhiệm vụ gần đây',
          tabBarIcon: ({ focused }) => (
            <TabIcon
              name={isAdmin ? 'scale-outline' : isOwner ? 'storefront-outline' : 'location-outline'}
              focused={focused}
            />
          ),
        }}
      />
      <Tabs.Screen
        name="tasks"
        options={{
          title: isAdmin ? 'Báo cáo' : isOwner ? 'Duyệt bài' : 'Nhiệm vụ của tôi',
          tabBarIcon: ({ focused }) => (
            <TabIcon name={isAdmin ? 'flag-outline' : 'clipboard-outline'} focused={focused} />
          ),
        }}
      />
      <Tabs.Screen
        name="wallet"
        options={{
          title: isAdmin ? 'Duyệt nhiệm vụ' : 'Ví',
          tabBarIcon: ({ focused }) =>
            isAdmin ? (
              <TabIcon name="add-circle-outline" focused={focused} />
            ) : (
              <CoinIcon size={focused ? 24 : 21} />
            ),
        }}
      />
      <Tabs.Screen
        name="profile"
        options={{
          title: 'Hồ sơ',
          tabBarIcon: ({ focused }) => <TabIcon name="person-outline" focused={focused} />,
        }}
      />
    </Tabs>
  );
}
